<template>

	<div class="modal no-default">

		<div class="modal-wrap">

			<div class="modal-inner">

				<h2 class="modal-title">Gift Some Analysis Credits<span class="close" @click="close">X</span></h2>

				<div class="modal-inner-scroll">

					<form class="form normal" @submit.prevent="">

						<FormInput type="number" label="Credits" v-model="credits" placeholder="0" />

						<FormInput type="number" label="Valid For How Many Days?" v-model="expiry" placeholder="30" :required="false" />

						<label>Access</label>
						<v-select 
							v-model="devAccess" 
							:options="devOps" 
							:reduce="option => option._id"
							:append-to-body="true"
							:multiple="true"
							placeholder="What can they access?"
						/>

						<span class="large-button" @click="addCredits">Save</span>

					</form>

					<div class="purchases-wrap">

						<h4>Current Analysis Credits</h4>

						<AnalysisCreditsPurchases
							v-if="gotTotals"
							:isAdmin="true"
							:totals="totals"
							@deleteCredits="deleteCredits"
						/>

					</div>

				</div>

			</div>

		</div>

	</div>

</template>

<script>
import { mapMutations } from 'vuex'
import ApiService from './../services/api.service'
import FormInput from './Form/Input.vue'
import AnalysisCreditsPurchases from './AnalysisCreditsPurchases.vue'
export default {
	name: 'AddAnalysisCredits',
	components: {
		FormInput,
		AnalysisCreditsPurchases
	},
	props: {
		userId: {
			type: String,
			required: true
		}
	},
	data() {

		return {
			totals: {},
			gotTotals: false,
			credits: '',
			expiry: '',
			devAccess: [],
			devOps: [
				{ _id: 'analysis-keywords', label: 'Keyword Analysis' },
				{ _id: 'analysis-domains', label: 'Website Analysis' }
			]
		}

	},
	computed: { 
		buttonText () {

			return 'Save';

		}

    },
	mounted() {

		this.getCurrent ();

	},

	methods: {

		...mapMutations('general',['updateLoadingText']),

		getCurrent () {

			ApiService.get( 'admin/analysis-credits/' + this.userId )
	        .then( function( info ) {

				this.totals = info.data.totals;
				this.devAccess = info.data.devAccess;
				this.gotTotals = true;

	        }.bind(this))
	        .catch( function(err) {
	            console.log(err);
	        });

		},

		close() {

			this.$emit('close');

		},
		deleteCredits (_id) {

			this.updateLoadingText('Deleting credits...');

			ApiService.delete( 'admin/analysis-credits/' + _id )
	        .then( function( info ) {

				this.getCurrent();
				this.updateLoadingText();
				this.reloadUsers();
				this.$snotify.success("The credits have been deleted", "Delete Credits");

	        }.bind(this))
	        .catch( function(err) {
	            console.log(err);
	        });

		},

	    addCredits() {

	    	this.updateLoadingText('Adding credits...');

			ApiService.post( 'admin/analysis-credits/' + this.userId, { expiry: this.expiry || 30, credits: this.credits, devAccess: this.devAccess } )
	        .then( function( info ) {

				this.getCurrent();
				this.updateLoadingText();
				this.reloadUsers();
				this.$snotify.success("The credits have been added", "Add Credits");
				this.credits = '';
				this.expiry = '';

	        }.bind(this))
	        .catch( function(err) {
	            console.log(err);
	        });

	    },

		reloadUsers () {

			this.$emit('reloadUsers');

		}

	}
}
</script>

<style lang="less" scoped>
@import './../assets/css/less/_settings.less';
@import './../assets/css/less/_helper.less';
.modal {
	.modal-inner {
		max-width: 626px;

		.modal-inner-scroll {

			overflow-y: auto;

			.btn-wrap {

				position: relative;
				z-index: 2;

			}

		}

		.purchases-wrap {

			background-color: @highlightGrey;
			padding: 15px 0 0 15px;
			margin-top: 20px;

			h4 {

				margin-bottom: 10px;

			}

		}

	}
}

</style>